import type { HTMLAttributes } from 'react';

export function Screen({
  className = '',
  children,
  ...rest
}: HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      className={`ma-screen ${className}`}
      {...rest}
    >
      <div className="mx-auto flex min-h-full w-full max-w-md flex-col px-4 pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.25rem,env(safe-area-inset-top))]">
        {children}
      </div>
    </div>
  );
}
